import React from "react";

const CuurentStateBtn = ({ state }) => {
  const statesArray = [
    {
      state: "pending",
      text: "درحال بررسی",
      className: "text-secondary-90 bg-[#CED3D9] px-[10px] py-1 rounded-md  text-title-sm-regular",
    },
    {
      state: "approved",
      text: "تایید شده",
      className: " px-[10px] py-1 rounded-md text-success-60 bg-success-10 text-title-sm-regular",
    },
    {
      state: "denied",
      text: "رد شده",
      className: "text-error-90 bg-error-20 px-[10px] py-1 rounded-md  text-title-sm-regular",
    },
  ];

  const activeItem = statesArray.find((item) => item.state === state);

  return <div className={activeItem?.className}>{activeItem?.text}</div>;
};

export default CuurentStateBtn;
